import $ from 'jquery';
import { clientVersion } from '@trello/config';

$(document).ajaxSend(function (
  e: Error,
  xhr: XMLHttpRequest,
  settings: { url: string },
) {
  // We only want to set this header on local requests, otherwise we'll break
  // things like loading off domain plugins
  if (settings.url.indexOf('/') === 0) {
    xhr.setRequestHeader('X-Trello-Client-Version', clientVersion);
  }
});
